/*
 * MAIN SCRIPT
 * DON'T WRITE FUNCTION HERE, ONLY CALL THEM
 *
 * **/
// document event listeners
document.addEventListener('DOMContentLoaded', (event) => {
    const formValidation = new FormsValidation();
    formValidation.initFormsValidation();
    const cardAnimation = new CardAnimation();
    const cardAnimationconfig = new CardAnimationConfig();
    cardAnimationconfig.delay = 400;
    cardAnimation.initCardsAnimation(cardAnimationconfig);
    initVideoListHeading();
    initTakeScreenshot();
    initMouseOverToggler();
    initModalResponse();
    initLoadMore();
    initPaginationComponent();
    initFilter();
    initToggler();
    initMappedImage();
    initFadeInAnimations();
    initCardSliderWidget();
    initTimelineWidget();
    initFormsExternalScripts();
    initAccordionComponent();
    initProductHeadingWidget();
    initTabComponent();
    initGenericListingWidget();
    initGallerygWidget();
    initWhoWheAreWithSliderAndNumbers();
    initTabList();
    initScrollAnimatedVideo();
    initColumnsTextWithGalleryAndBackgroundWidget();
    initProduct();
    megamenuT2();
    initMapScript();
    //@ts-ignore
    //imageMapResize();
});
